import type { StickerStatus } from '../../types';

interface StatusBadgeProps {
  status: StickerStatus;
  size?: 'sm' | 'md';
}

const config: Record<StickerStatus, { bg: string; text: string; dot: string; label: string }> = {
  FALTA:     { bg: 'bg-red-100',   text: 'text-red-700',   dot: 'bg-red-500',   label: 'Falta' },
  TENGO:     { bg: 'bg-green-100', text: 'text-green-700', dot: 'bg-green-500', label: 'Tengo' },
  DUPLICADA: { bg: 'bg-amber-100', text: 'text-amber-700', dot: 'bg-amber-500', label: 'Duplicada' },
};

export function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const { bg, text, dot, label } = config[status];
  const padding = size === 'md' ? 'px-3 py-1 text-sm' : 'px-2.5 py-0.5 text-xs';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-bold ${bg} ${text} ${padding}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dot}`} />
      {label}
    </span>
  );
}
